import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export default function useFetchPredictCompute(tenant: number, email: string) {
  return useQuery<Record<string, any>>(
    ['profile-predict-compute', tenant, email],
    async () => {
      const { data: predictResult } = await axios.post(
        `${getBongoUrl()}/v1/org/${tenant}/predict/compute`,
        {
          email,
        }
      );

      return predictResult;
    }
  );
}
